import type { NotifyPort } from '@/features/messages/domain/notify'
import type { EmergencyContact, MemberPort } from '../domain/member'

const addEmergencyContact = async (
	port: MemberPort,
	memberId: string,
	contact: Omit<EmergencyContact, 'id'>,
	notify: NotifyPort,
): Promise<EmergencyContact> => {
	try {
		return await port.addEmergencyContact(memberId, contact)
	} catch (err) {
		notify.error('hr.emergencyContactAddFailed')
		throw err
	}
}

const removeEmergencyContact = async (
	port: MemberPort,
	memberId: string,
	contactId: string,
	notify: NotifyPort,
): Promise<void> => {
	try {
		await port.removeEmergencyContact(memberId, contactId)
	} catch {
		notify.error('hr.emergencyContactRemoveFailed')
		throw new Error('Failed to remove emergency contact.')
	}
}

export { addEmergencyContact, removeEmergencyContact }
